import React from 'react';
import { observer } from 'mobx-react';
import ExcelTableTds from './TableTds';
import CardStore from '../../stores/card';
import { getRowIndex } from '../../util/typeUtil';
import ModeExcel from '../../stores/card/ModeExcel';

export interface ExcelTableCellDetailTBodyProps {
    excel?: ModeExcel;
    form: any
    card: CardStore;
    detail?: string;
    isButton?: boolean;
    isNeedPagination: boolean;
    ishead?: boolean;
    rowspanJson?: any;
}

@observer
export default class DetailTop extends React.Component<ExcelTableCellDetailTBodyProps, any>{
    renderTableTrs = () => {
        const { excel, card, detail } = this.props;
        const { edtitleinrow = '0', edtailinrow = "0", rows = [] } = excel || {};
        let headRow = parseInt(edtitleinrow, 0);
        let bodyRow = parseInt(edtailinrow, 0);
        let _rowhead = rows.slice();
        if (headRow == 0 || bodyRow == 0 || bodyRow <= headRow) {
            return ([[<div>对不起，表头标识、表尾标识设置异常，无法渲染明细！</div>]])
        }
        return excel ? _rowhead.map((row) => {
            const rowIndex: number = getRowIndex(row.id);
            let trs: JSX.Element[] = [];
            if (rowIndex == headRow + 1) {
                return;
            } else if (rowIndex < (headRow == 2 ? headRow - 1 : 1)) { //当头部出现合并行后锁定列要多减1
                trs.push(<tr style={{ height: row.size }} className="cube-detailbtn-edit-tr" >
                    <ExcelTableTds ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableTds@fafq4j@${rowIndex}`} row={getRowIndex(row.id)} card={card} excel={excel} form={card.cubeForm} detail={detail} isFixFieldDiv={false} isTitle={false} />
                </tr>)
            }
            return trs
        }) : [];
    }
    render() {
        const { excel, } = this.props;
        const { edtitleinrow = '0' } = excel || {};
        if(edtitleinrow== '1'){    return null   }
        return (<div className="cube-detail-locked-btnrow">
            <div className="cube-detail-locked-btnrow-content">
                <table className="cube-detail-locked-btnrow-table">
                    <tbody>
                        <tr className="detailControlWidth">
                            {
                                excel && excel.cols.slice().map(({ size, hide }, index) => {
                                    return (
                                        <td style={{ display:hide && hide ==="y" ? "none":"",width: size, }} />
                                    )
                                })
                            }
                        </tr>
                        {this.renderTableTrs()}
                    </tbody>
                </table>
            </div>
            <div className="cube-detail-locked-btnrow-placeholder"></div>
        </div>)
    }

}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/DetailTop.tsx